import { POST } from '@/utils/request'
import Api from './url'
export const getList = async (params: object) => {
  return await POST({ url: Api.getList, data: params, showError: false })
}

// 线下任务预约、取消预约、重新预约
export const booking = async (params: object) => {
  return await POST({ url: Api.booking, data: params, showError: false })
}
export const taskDetail = async (params: object) => {
  return await POST({ url: Api.taskDetail, data: params, showError: false })
}
export const waitTrain = async (params: object) => {
  return await POST({ url: Api.waitTrain, data: params, showError: false })
}
export const resultBooking = async (params: object) => {
  return await POST({ url: Api.resultBooking, data: params, showError: false })
}

// 查询培训站点列表
export const getSiteList = async (params: object) => {
  return await POST({ url: Api.siteList, data: params, showError: false })
}

// 查询培训场次列表
export const getTimeSlotList = async (params: object) => {
  return await POST({ url: Api.timeSlotList, data: params, showError: false })
}
